import React from "react";
import Modal from "react-modal";
import { Button } from "../../../common/Button/Button";
import { ControlledInput } from "../../../common/Input/Input";
import ModalContent from "../../../common/Modal/ModalContent";
import Spinner from "../../../common/Spinner/Spinner";
import Select from "react-select";
import close_modal from "./../../../assets/ic_close_wh.svg";

Modal.setAppElement("#root");

export default function CancellationReasonModal({ neftDetails, ...props }) {
	return (
		<>
			<Modal
				isOpen={props.isOpen}
				onRequestClose={props.toggleModal}
				ariaHideApp={false}
			>
				<ModalContent className="general-modal">
					{/* {props.isLoading && <Spinner className="center" />} */}
					<div className="modal-header">
						<span className="modal-title">Cancellation Reason</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={props.toggleModal}
						/>
					</div>
					<div className={`modal-body spled-container  ${props.isLoading && "set-opacity"}`}>
						<div className="row conv-pt15 conv-pb15">
							{props.isLoading && <Spinner className="center" />}
							<div className="col-12 conv-pl20 conv-pr20">
								<label className="my-services-model-value">Cancellation Reason:</label>
								<Select
									styles={{
										// Fixes the overlapping problem of the component
										menu: provided => ({ ...provided, zIndex: 3 })
									}}
									className='react-select-container'
									classNamePrefix="react-select"
									theme={theme => ({
										...theme,
										colors: {
											...theme.colors,
											primary: '#76287C',
											primary25: '#F4DFF4',
										},
									})}
									options={props.cancellationReasonDropdownOptions}
									onChange={props.onSelectCancellationReason}
									value={props.selectedCancellationReason}
									isClearable
								/>
							</div>
							{
								props.enableOtherDescriptionTextbox ?
									(
										<div className="col-12 conv-mt25 conv-pl20 conv-pr20">
											<label className="my-services-model-value">Other Cancellation Reason:</label>
											<ControlledInput
												placeholder="Please specify a reason here"
												// onChange={(event) => { event.persist();debounce(() => {props.onSearchInputChange(event)},1000)}}
												onChange={({ target }) =>
													props.onChangeCancellationReasonOtherDescription(
														target.value
													)
												}
												value={props.cancellationReasonOtherDescription}
											/>
										</div>
									) : ("")
							}
							<div className="col-12 conv-mt25 conv-pl20 conv-pr20">
								<button
									type="button"
									className={`my-services-model-submit-btn conv-mr25
								${props.isDisabled}`}
									onClick={() => {
										if (props.forSPM) props.onChangeState();
										else props.onChangeState("Cancelled");
									}}>
									Cancel Service Request
								</button>
								<button
									type="button"
									className={`my-services-model-cancel-btn `}
									onClick={props.toggleModal}>
									Cancel
								</button>

							</div>
						</div>

					</div>
				</ModalContent>
			</Modal>

			<Modal isOpen={props.confirmCancelModal} style={{ zIndex: 1 }}>
				<ModalContent className="confirmation-modal-small">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Confirm</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={props.openConfirmCancelModalisFalse}
						/>
					</div>

					<div className="modal-body">
						Are you sure you want to perform this action? This will cancel all the services in package.
						<div className="row">
							<div className="col-12 d-flex align-items-center" style={{
								justifyContent: 'flex-end'
							}}>
								<button
									type="button"
									className="my-services-model-submit-btn conv-mr25"
									onClick={props.onConfirmCancelClick}
								>
									Yes
								</button>
								<button
									type="button"
									className="my-services-model-cancel-btn conv-mr25"
									onClick={() => {
										props.openConfirmCancelModalisFalse()
									}}
								>
									No
								</button>
							</div>

						</div>
					</div>
				</ModalContent>
			</Modal>
		</>
	);
}
